module.exports = __webpack_public_path__ + "img/updown1.3187aa35.png";